import React, { useState } from 'react';
import styled from 'styled-components';
import { black } from 'constants/variables';

export interface ToolTipsProps {
  children: React.ReactNode;
  toolTipIcon?: React.ReactNode;
  closeIcon?: React.ReactNode;
  className: string;
  bgColor: string;
}

interface ToolTipStyle {
  bgColor?: string;
  visible: boolean;
}

const StyledToolTip = styled.div<ToolTipStyle>`
  background-color: ${({ bgColor }) => bgColor || black};
  position: absolute;
  z-index: 1;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-bottom: 0.5rem solid transparent;
    border-bottom-color: ${({ bgColor }) => bgColor || black};
    margin: 0 0 0 -0.5rem;
  }
`;

const ToolTipCloseIcon = styled.button`
  position: absolute;
  top: 5%;
  right: 2%;
`;

const ToolTip = ({
  bgColor,
  className,
  children,
  toolTipIcon,
  closeIcon,
}: ToolTipsProps) => {
  const [visible, setVisible] = useState(false);

  const toggleTooltip = () => {
    setVisible(!visible);
  };

  const hideToolTipWithKeyPress = (e: any) => {
    const { key } = e;
    if (key === 'Escape') {
      setVisible(false);
    }
  };

  return (
    <button
      type="button"
      className={`ml-6 tooltip-button ${visible && 'tooltip-button-show'}`}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      onClick={() => toggleTooltip()}
      onKeyDown={e => hideToolTipWithKeyPress(e)}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}>
      {toolTipIcon}
      <StyledToolTip
        role="tooltip"
        className={className}
        bgColor={bgColor}
        visible={visible}>
        {closeIcon && (
          <ToolTipCloseIcon
            role="button"
            onClick={() => setVisible(false)}
            onBlur={() => setVisible(false)}>
            {closeIcon}
          </ToolTipCloseIcon>
        )}
        {children}
      </StyledToolTip>
    </button>
  );
};

export default ToolTip;
